
<template>
  <div>
    <div
      v-for="(space, i) in spaces"
      :key="i"
      :class="{
        'pt-5': !mini,
        'pt-2': mini,
      }"
    >
      <space-btn :space="space" :mini="mini" />
    </div>
    <v-row no-gutters justify="center" align="center" class="mt-10" v-if="canLogout">
      <n-card
        clickable-shadow
        class="py-2 px-6"
        @click="logout"
      >
        <v-row no-gutters justify="center" align="center">
          <div class="font-weight-medium" style="font-size: 0.9rem;">
            Se déconnecter
            <v-icon small class="ml-1" style="margin-top: -2px;">logout</v-icon>
          </div>
        </v-row>
      </n-card>
    </v-row>
  </div>
</template>

<script>
import SpaceBtn from './SpaceSelector/SpaceBtn.vue';

export default {
  props: {
    spaces: {
      type: Array,
      required: true,
    },
    canLogout: {
      type: Boolean,
      required: false,
      default: false,
    },
    mini: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  methods: {
    async logout() {
      await this.$store.dispatch(`model/auth/logout`);
      if (this.$route.name !== `login`) {
        this.$router.push({ name: `login` });
      }
    },
  },

  components: {
    SpaceBtn,
  },
};
</script>
